module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patricia MacLachlan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patricia MacLachlan is the celebrated author of many timeless books for young readers, including "), _c('i', [_vm._v("Sarah, Plain and Tall")]), _vm._v(", winner of the Newbery Medal. She lives with her husband and two border terriers in Williamsburg, Massachusetts. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RCOymO/tc-custom/9781442460102.jpg?1730537808232",
      "alt": "This image is the cover for the book Fly Away"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fly Away\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the Newbery Award–winning author of "), _c('i', [_vm._v("Sarah, Plain and Tall")]), _vm._v(" comes a story about one brave girl who saves her family from losing everything. In a starred review, "), _c('i', [_vm._v("Publishers Weekly ")]), _vm._v("calls this lyrical tale “melodic, poetic, and enchanting.”")]), _c('br'), _c('br'), _vm._v("Everyone in Lucy’s family sings. Opera. Rap. Lullabies. Everyone, except Lucy. Lucy can’t sing; her voice won’t come out."), _c('br'), _c('br'), _vm._v("Just like singing, helping Aunt Frankie prepare for flooding season is a family tradition—even if Frankie doesn’t want the help. And this year, when the flood arrives and danger finds its way into the heart of Lucy’s family, Lucy will need to find her voice to save her brother."), _c('br'), _c('br'), _vm._v("“Filled with little moments of quiet wisdom and gentle humor, Newbery winner MacLachlan's story about family love soars” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(", starred review).\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Margaret K. McElderry Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0